import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';
import { getLinkElement, getPotentialLinkMailtoHref } from '@/lib/link-config';

import { LinkButtonProps } from '@/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';

import { passPhTracker } from '@/integrations/trackingScripts/utils';
import { removeEmptyKeys } from '@/utils/removeEmptyKeys';

export function transformFromCMSLink(block: LinkButtonStrapiProps) {
  const { url, openInNewTab, ...restBlock } = block || {};

  const updatedHref = url?.replace(currentLocaleConfig().url, '');

  return removeEmptyKeys({
    ...restBlock,
    openInNewTab,
    target: openInNewTab ? '_blank' : undefined,
    href: updatedHref || '#',
    ...passPhTracker(block?.phTracker),
  }) as LinkButtonProps;
}

export function transformLinkToButtonProps(link: LinkButtonStrapiProps): {
  href: string;
  target: '_blank' | '_self';
  element: 'a' | 'nextlink' | 'button';
  text?: string;
} {
  const { url, openInNewTab } = link || {};
  const updatedHref = url?.replace(currentLocaleConfig().url, '') || '#';

  return {
    href: getPotentialLinkMailtoHref(updatedHref),
    target: (openInNewTab ? '_blank' : '_self') as '_blank' | '_self',
    element: getLinkElement(updatedHref),
    text: link.text,
    ...passPhTracker(link?.phTracker),
  };
}
